export default {
    direction: "rtl",
    palette: {
        type: 'dark',
        primary: {
            main: '#2680EB'
        },
        // background: {
        //     default: '#F3F3F3'
        // }
    },
    typography: {
        fontFamily: '"Bahij_TheSansArabic-Bold", "Tajawal", "Roboto", "Helvetica", "Arial", "sans-serif"'
    },
    // overrides: {
    //     MuiCssBaseline: {
    //         '@global': {
    //             '@font-face': [Bahij],
    //         },
    //     },
    // },
};